import Image from '@jetshop/ui/Image/Image';
import { Price } from '@jetshop/ui/Price';
import ProductLink from '@jetshop/ui/ProductLink';
import React, { Fragment } from 'react';
import styled, { css } from 'react-emotion';
//import Badges from './Badges';
import Badges from '@jetshop/ui/ProductList/Badges';

import { ReactComponent as LogoSulman } from '../../images/logo-sulman.svg';
import { ReactComponent as LogoAlpina } from '../../images/logo-alpina.svg';
import { ReactComponent as LogoPowerboots } from '../../images/logo-powerboots.svg';

const StyledLogoAlpina = styled(LogoAlpina)`
  width: calc(105px * 1);
  height: calc(24px * 1);
  ${({ theme }) => theme.below.md} {
    width: calc(103px * 0.6);
    height: calc(24px * 0.6);
  }
`;

const StyledLogoSulman = styled(LogoSulman)`
  width: calc(103px * 0.8);
  height: calc(24px * 0.8);
  ${({ theme }) => theme.below.md} {
    width: calc(103px * 0.6);
    height: calc(24px * 0.6);
  }
`;

const StyledLogoPowerboots = styled(LogoPowerboots)`
  width: calc(82px * 0.8);
  height: calc(58px * 0.8);
  ${({ theme }) => theme.below.md} {
    width: calc(103px * 0.5);
    height: calc(24px * 0.5);
  }
`;

const LogoWrapper = styled('div')`
  position: absolute;
  top: ${({ theme }) => theme.space[2]};
  right: ${({ theme }) => theme.space[2]};
  z-index: 3;
  ${({ theme }) => theme.below.md} {
    top: 0;
  }
`;

export const ProductWrapper = styled('div')`
  width: 50%;
  ${({ theme }) => theme.above.md} {
    width: 50%;
  }
  ${({ theme }) => theme.above.lg} {
    width: 25%;
  }
`;

export const Name = styled('p')`
  margin-bottom: 0.25rem !important;
  font-size: 0.875rem;
  /* color: ${({ theme }) => theme.colors.themeGreyDark}; */
  color: #484848;
  text-transform: uppercase;
  transition: color ease-in-out 0.1s;
`;

export const SubName = styled('p')`
  margin-bottom: 0.5rem !important;
  font-size: 0.75rem;
  color: ${({ theme }) => theme.colors.themeGreyDark};
  text-transform: uppercase;
  transition: color ease-in-out 0.1s;
`;

const StyledPrice = styled(Price)`
  display: flex;
  align-items: center;
  font-size: 1rem;
  color: #000;
  font-weight: bold;
  transition: color ease-in-out 0.1s;

  ${Price.New} {
    display: inline-block;
    order: 2;
    margin-left: 1rem;

    ${({ theme }) => theme.below.md} {
      display: block;
      margin-top: 0.5rem;
      margin-left: none;
    }
  }

  ${Price.Old} {
    display: inline-block;
    order: 1;

    ${({ theme }) => theme.below.md} {
      margin-top: 0.5rem;
      display: block;
    }
  }

  ${({ theme }) => theme.below.sm} {
    flex-direction: column;
    align-items: start;
  }

  ${Price.New} {
    ${({ theme }) => theme.below.sm} {
      margin-left: 0;
    }
  }
`;

export const ProductDetails = styled('div')`
  padding: ${({ theme }) => theme.space[1]};
  padding-bottom: 0;
  width: 100%;
  max-width: 100%;
  max-height: 100%;
  /* position: absolute; */
  //bottom: 0;
  /* top: calc(100% - 50px); */
  left: 0;
  z-index: 2;
  //padding-left: 0; //border test
  //padding-right: 0; //border test
  ${({ theme }) => theme.below.md} {
    position: relative;
    padding: 0;
    top: 0;
    margin-top: 0.5rem;
  }
`;

const ProductDetailsInner = styled('div')`
  display: inline-block;
  position: relative;
  padding: 7px 10px;
  overflow: hidden;
  color: #fff;
  transition: top ease-in-out 0.1s;
  // width: 100%; //border test

  ${({ theme }) => theme.below.md} {
  }

  > p,
  > div {
    position: relative;
  }

  &:before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    top: 100%;
    left: 0;
    transition: top ease-in-out 0.1s;
    background: ${({ theme }) => theme.colors.themeBlack};

    ${({ theme }) => theme.below.md} {
      display: none;
    }
  }

  ${({ theme }) => theme.below.md} {
    padding: 0;
  }
`;

export const ProductBlockLink = styled(ProductLink)`
  display: block;
  min-height: 292px;
  position: relative;
  margin-right: ${({ theme }) => theme.space[1]};
  margin-left: ${({ theme }) => theme.space[1]};
  margin-bottom: ${({ theme }) => theme.space[4]};
  padding-bottom: 0;
  text-decoration: none;
  color: inherit;

  ${({ theme }) => theme.below.md} {
    background-color: transparent;
    min-height: 0px;
  }

  ${({ theme }) => theme.below.md} {
    margin-bottom: ${({ theme }) => theme.space[5]};
  }
  &:hover {
    ${ProductDetailsInner} {
      &:before {
        top: 0;
      }
      ${Name}, ${SubName}, ${StyledPrice} {
        color: #fff !important;
      }
    }
  }
`;

const StyledImaged = styled(Image)`
  background-size: 70% !important;

  /* padding-top: 90% !important; */
`;

const GridProduct = ({
  product,
  categoryPath,
  loading,
  imageAspect = '1:1',
  className = ''
}) => {
  console.log('product', product);
  return React.createElement(
    ProductWrapper,
    { 'data-testid': 'product', className: className },
    React.createElement(
      ProductBlockLink,
      {
        product: product,
        categoryPath: categoryPath,
        className:
          loading &&
          css`
            opacity: 0.5;
          `
      },

      product.customFields && product.customFields.length
        ? product.customFields.map((field, i) => {
            const fieldLabel =
              field.title === 'Varumärke' ? field.title : undefined;
            let LogoSVG = Fragment;
            if (fieldLabel) {
              const brandName = field.stringValue;
              switch (brandName) {
                default:
                  return null;
                case 'Sulman':
                  LogoSVG = StyledLogoSulman;
                  break;
                case 'Alpina':
                  LogoSVG = StyledLogoAlpina;

                  break;
                case 'Powerboots':
                  LogoSVG = StyledLogoPowerboots;
                  break;
              }
            }

            return fieldLabel
              ? React.createElement(LogoWrapper, { key: i }, <LogoSVG />)
              : null;
          })
        : null,

      product.images.length > 0 &&
        React.createElement(
          StyledImaged,
          {
            sizes: [1 / 4, 1 / 3, 1 / 2, 1 / 2],
            aspect: imageAspect,
            alt: product.images[0].alt,
            src: product.images[0].url
          },
          React.createElement(Badges, { badges: product.badges })
        ),
      React.createElement(
        ProductDetails,
        null,
        React.createElement(
          ProductDetailsInner,
          null,
          React.createElement(Name, null, product.name),
          React.createElement(SubName, null, product.subName),
          React.createElement(StyledPrice, {
            price: product.price,
            recommendedPrice: product.recommendedPrice,
            previousPrice: product.previousPrice
          })
        )
      )
    )
  );
};
export default GridProduct;

